import { render, staticRenderFns } from "./withdrawAuditList.vue?vue&type=template&id=56a31af4&scoped=true&lang=pug&"
import script from "./withdrawAuditList.vue?vue&type=script&lang=ts&"
export * from "./withdrawAuditList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a31af4",
  null
  
)

export default component.exports